import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IYearlevel_map } from "../../../Pages/Yearlevel_map/IYearlevel_map";

export const DeleteYearlevel_mapSlice = createSlice({
  name: "DeleteYearlevel_map",
  initialState: {} as IReduxState<IYearlevel_map>,
  reducers: {
    deleteYearlevel_map: (state, _) => {
      state.isLoading = true;
    },
    successdeleteYearlevel_map: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failuredeleteYearlevel_map: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDeleteYearlevel_mapResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteYearlevel_map,
  failuredeleteYearlevel_map,
  successdeleteYearlevel_map,
  clearDeleteYearlevel_mapResponse,
} = DeleteYearlevel_mapSlice.actions;

export default DeleteYearlevel_mapSlice.reducer;
